import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "plena_admin_token";

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY) || "";
export const setAdminToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));
export const adminHeaders = () => ({ "X-Admin-Token": getAdminToken() });
export const assetUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export const errorText = (e, fallback = "Bir şeyler ters gitti") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
};
